import { lazyLoad } from 'utils/loadable';

export const ResetPassword = lazyLoad(
  () => import('./ResetPasswordPage'),
  module => module.ResetPassword,
);
